import { Button, Link, LoadingButton } from '@one-thd/sui-atomic-components';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { useReturnStore } from '../../stores/returnStore';
import { redirectToOrderDetails } from '../../utils/general';

interface IReturnButtonsProps {
  disabled?: boolean;
  proceedBack?: () => void;
  proceedNext: () => void;
  final?: boolean;
  instore?: boolean;
  isError?: boolean;
  loading?: boolean;
}

export const ReturnButtons = ({
  disabled = false,
  proceedBack,
  proceedNext,
  final = false,
  instore = false,
  isError = false,
  loading = false,
}: IReturnButtonsProps) => {
  const isMilitaryExchangeGuest = useReturnStore(
    (state) => state.isMilitaryExchangeGuest,
  );
  const orderDetailsPath = useReturnStore((state) => state.orderDetailsPath);
  const nextButtonText = () => {
    if (final) return 'Finalize Return';
    if (instore) return 'Return to Order Details';
    if (isError) return 'Retry';
    return 'Continue';
  };

  return (
    <div className="sui-mt-12 sui-flex sui-flex-col sui-justify-end sui-items-center sm:sui-mt-[60px] sm:sui-flex-row">
      <div className="sui-flex sui-flex-col sui-gap-4 sui-w-full sm:sui-w-auto sm:sui-flex-row-reverse">
        <LoadingButton
          data-testid="proceed-button"
          variant="primary"
          type="button"
          onClick={() => proceedNext()}
          fullWidth={isMobile}
          disabled={disabled}
          loading={loading}
        >
          <span className="sui-whitespace-nowrap">{nextButtonText()}</span>
        </LoadingButton>
        {proceedBack && (
          <Button
            data-testid="back-button"
            variant="secondary"
            type="button"
            onClick={() => proceedBack()}
            fullWidth={isMobile}
          >
            Go Back
          </Button>
        )}
      </div>
      {!instore && (
        <div className="sui-mt-7 sm:sui-order-first sm:sui-mt-0 sm:sui-mr-7">
          <Link
            onClick={() =>
              redirectToOrderDetails(orderDetailsPath, isMilitaryExchangeGuest)
            }
          >
            Cancel Return
          </Link>
        </div>
      )}
    </div>
  );
};
